import { match } from 'ts-pattern';
import { useGetIGInsights } from '~/hooks/api/insights/useGetIGInsights';
import { useGetSnapchatInsights } from '~/hooks/api/insights/useGetSnapchatInsights';
import { useGetTTInsights } from '~/hooks/api/insights/useGetTTInsights';
import { useGetYTInsights } from '~/hooks/api/insights/useGetYTInsights';
import { Platform } from '~/screens/AddTalent/constants';

type Props = {
  insightId: string;
  platform: Platform;
};
export const useInsights = ({ insightId, platform }: Props) => {
  const igInsights = useGetIGInsights({
    id: platform === 'instagram' ? insightId : undefined,
  });
  const ttInsights = useGetTTInsights({
    id: platform === 'tiktok' ? insightId : undefined,
  });
  const ytInsights = useGetYTInsights({
    id: platform === 'youtube' ? insightId : undefined,
  });
  const snapchatInsights = useGetSnapchatInsights({
    id: platform === 'snapchat' ? insightId : undefined,
  });

  const result = match(platform)
    .with('instagram', () => igInsights)
    .with('tiktok', () => ttInsights)
    .with('youtube', () => ytInsights)
    .with('snapchat', () => snapchatInsights)
    .otherwise(() => null);

  // Ensure we return the correct result with properly scoped loading states
  // When no valid platform is matched, return an idle state
  if (!result) {
    return {
      data: undefined,
      isLoading: false,
      isFetching: false,
      isError: false,
      error: null,
    };
  }

  // If insightId is empty/falsy, the query should not be loading
  // This explicitly handles cases where the query might be in an incorrect loading state
  if (!insightId) {
    return {
      ...result,
      isLoading: false,
      isFetching: false,
    };
  }

  return result;
};
